module.exports = __webpack_public_path__ + "media/images/emblems/Haeggenschwil-4d1fc57f0ff400fd9591a2817cd58934.png";